import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../../store/dateReducer";
import { useTranslation } from "react-i18next";
import convertDateByTimezone from "../../utils/workingWithDateTime/convertDateByTimezone";
import { useEffect, useMemo } from "react";
import { DateTime } from "luxon";
const FreeTimeComponent = ({ intervals, employeeId, closestDate }) => {
    const { t: translate } = useTranslation();

    const picketDate = useSelector((state) => state.dateReducer.currentDate);
    const timeZone = useSelector((state) => state.branchReducer.timeZone);
    const pickedTime = useSelector((state) => state.dateReducer.pickedTime);
    const dispatch = useDispatch();

    const selectedDT = useMemo(() => {
        if (picketDate) {
            return DateTime.fromISO(String(picketDate), { setZone: true }).setZone(timeZone);
        }
        if (closestDate) {
            return DateTime.fromISO(String(closestDate), { setZone: true }).setZone(timeZone);
        }
        return convertDateByTimezone(timeZone);
    }, [picketDate, closestDate, timeZone]);

    const baseDay = useMemo(() => selectedDT.startOf("day"), [selectedDT]);

    const nowTZ = useMemo(() => DateTime.now().setZone(timeZone), [timeZone]);
    const isToday = baseDay.hasSame(nowTZ, "day");

    useEffect(() => {
        if (!pickedTime) {
            document.querySelectorAll(".time-btn.active").forEach((btn) => btn.classList.remove("active"));
        }
    }, [pickedTime, intervals, timeZone]);

    const pickTimeHandler = (event) => {
        const btn = event.currentTarget;
        const cls = btn.classList;

        if (cls.contains("active")) {
            cls.remove("active");
            dispatch(setDate({ pickedTime: null, dateIsEntered: false, timeIsPickedIn: null }));
            return;
        }

        document.querySelectorAll(".time-btn.active").forEach((b) => b.classList.remove("active"));
        cls.add("active");

        const isoZoned = btn.dataset.value;
        dispatch(
            setDate({
                pickedTime: isoZoned,
                dateIsEntered: false,
                timeIsPickedIn: employeeId,
            })
        );
    };

    const buttons = [];

    intervals?.forEach(({ start, end }, i) => {
        const [sh, sm = 0, ss = 0] = start.split(":").map(Number);
        const [eh, em = 0, es = 0] = end.split(":").map(Number);

        let startDT = baseDay.set({ hour: sh, minute: sm, second: ss, millisecond: 0 });
        const endDT = baseDay.set({ hour: eh, minute: em, second: es, millisecond: 0 });

        if (isToday && startDT < nowTZ) {
            const add = (15 - (nowTZ.minute % 15)) % 15;
            startDT = nowTZ.plus({ minutes: add }).set({ second: 0, millisecond: 0 });
            if (startDT > endDT) return;
        }

        const totalMin = Math.floor(endDT.diff(startDT, "minutes").minutes);
        const steps = Math.floor(totalMin / 15);

        for (let j = 0; j <= steps; j++) {
            const dt = startDT.plus({ minutes: 15 * j });
            if (dt > endDT) break;

            const label = dt.toFormat("HH:mm");
            const isoZoned = dt.toISO({ suppressMilliseconds: true });

            buttons.push(
                <button
                    key={`${i}-${isoZoned}`}
                    onClick={pickTimeHandler}
                    data-value={isoZoned}
                    data-zone={timeZone}
                    className="btn w-100 border text-center py-2 mb-2 fs-7 bg-white time-btn fw-normal"
                >
                    {label}
                </button>
            );
        }
    });

    return (
        <div className="work-time row px-2">
            {buttons.length !== 0 ? (
                buttons.map((btn, index) => (
                    <div key={index} className="col-lg-2 col-4 px-1">
                        {btn}
                    </div>
                ))
            ) : (
                <p className="text-secondary text-center mb-0">
                    {translate("masterListPage.notFoundFreeTime")}
                </p>
            )}
        </div>
    );
};

export default FreeTimeComponent;
